<template>
    <div class="search-wrapper">
        <div class="form-group mb-0">
            <input type="text" v-model="searchValue" :id="inputId" :name="inputId" :class="{'has-content': searchValue.length > 0, 'border-bottom border-danger': p_isInvalid}" :autocomplete="ac">
            <label :for="inputId" class="m-0 mr-2 col-form-label">{{searchText}}</label>
            <span class="focus-border"></span>
            <ul :id="listId" class="list-group shadow" style="max-height: 600px; overflow-y: auto; position: absolute; width: 100%">
                <li class="list-group-item font-italic" v-if="searchResults.length < 1 && !loading">
                    No results
                </li>
                <li class="list-group-item font-bold" v-else-if="loading">
                    <i class="fas fa-spinner fa-spin"></i>
                </li>
                <li class="list-group-item bg-white d-flex" v-for="(item, index) in searchResults" :key="index" @click="returnDetails(index)">
                    <span v-html="renderResult(item)"></span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['text', 'inputId', 'listId', 'results', 'autocomplete', 'alwaysShowResults', 'p_isInvalid', 'imagePath', 'result_type'],

        data() {
            return {
                searchText: this.text ? this.text : 'Search',
                searchResults: this.results ? this.results : [],
                loading: false,
                ac: null,
                searchValue: '',
                alwaysShow: this.alwaysShowResults ? true : false,
                searchDelay: 200,
                layout: null,
            }
        },

        mounted() {
            const self = this;

            if (!this.autocomplete) {
                this.ac = 'off';
            }

            $(this.$el).find('input').on('keyup', self.delayCallback(function(e) {
                self.loading = true;
                if(e.target.value.length < 1 && !self.alwaysShow) {
                    self.searchResults = [];
                    self.loading = false;
                    self.$emit('searchNull', e.target.value);
                }
                else {
                    self.$emit('search', e.target.value);
                }
            }, this.searchDelay));

            $(this.$el).find('input').on('focus', function(e) {
                $('#'+self.listId).show();
            }).on('blur', function(e) {
                $('#'+self.listId).hide();
            });

            $('#'+this.listId).on('mousedown', function(e) {
                e.preventDefault();
            });
        },

        methods: {
            returnDetails(index) {
                this.$emit('result', index);
                $(this.$el).find('input').blur();
                self.loading = false;
            },

            renderResult(obj) {
                let properties = [];
                let display = '<div class="w-100 d-flex align-items-center">';

                if (this.imagePath && obj[this.imagePath]) display += '<img class="d-inline mr-2" style="width:100px;" src="' + obj[this.imagePath] + '">';

                if(obj.result_type === 'school'){
                    display += '<div class="d-inline-block"><i class="fas fa-school fa-lg text-secondary mr-2"></i> <b>' + this.titleCase(obj['sch_name']) + ' #' + obj['schnum'] + '</b> ' + this.titleCase(obj['county']) + ', ' + obj['state'] + '</div>';
                }
                else if(obj.result_type === 'contract') {
                    display += '<div class="d-flex align-items-center"><i class="fas fa-receipt fa-lg text-secondary mr-2"></i> <div><b>' + this.titleCase(obj['sch_name']) + ' #' + obj['schnum'] + '</b> ' + this.titleCase(obj['county']) + ', ' + obj['state'] +'<br>';
                    display += `C${obj['contract_id']}`;
                    obj['season'] === 'F' ? display += ' Fall': display += ' Spring'
                    display += ' ' + obj['school_year'] + ' ' + this.titleCase(obj['description']) + '</div></div>';
                }
                display += '</div>'

                this.loading = false;
                return display;
            },

            setSearchTerm(term) {
                this.searchValue = term;
            },

            focusInput() {
                let self = this;
                this.$nextTick(function() {
                    if (self.inputId) $('#' + self.inputId)[0].focus();
                });
            }
        },

        watch: {
            results: function(newResult, oldResult) {
                this.searchResults = newResult;
                this.loading = false;
            }
        }
    }
</script>

<style lang="scss" scoped>

.list-group-item {
    padding: 0.5rem 1rem;
}

label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
